module.exports = __webpack_public_path__ + "img/blt-harekuraniokinawa.eee06aa8.svg";